// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

export const clearedAttributes = {
  alergia_alimentar: null,
  "Contato COVID positivo": null,
  "Conte pra mim os nomes dos medicamentos": null,
  "Data final a ser periciada": null,
  "Data inicial a ser periciada": null,
  "Data inicial dos sintomas": null,
  "Descreva em poucas palavras o que te faz buscar uma segunda opinião": null,
  "Descreva em poucas palavras os seus sintomas": null,
  documentacao_disponivel: null,
  documentacao_propria: null,
  documento_enviado: null,
  exames_lab_recentes: null,
  grupo_de_risco: null,
  "Identificação do usuário": null,
  informacao_medicamento: null,
  "Informe a letra inicial do primeiro CID do seu atestado": null,
  "Informe a letra inicial do quarto CID do seu atestado": null,
  "Informe a letra inicial do quinto CID do seu atestado": null,
  "Informe a letra inicial do segundo CID do seu atestado": null,
  "Informe a letra inicial do terceiro CID do seu atestado": null,
  "Informe a quantidade de dias de afastamento do seu atestado": null,
  "Informe o CPF do colaborador": null,
  "Informe o ano de emissão do seu atestado": null,
  "Informe o dia de emissão do seu atestado": null,
  "Informe o estado do CRM do médico": null,
  "Informe o mês de emissão do seu atestado": null,
  "Informe o nome completo do colaborador": null,
  "Informe o peso que você deseja atingir com o tratamento": null,
  "Informe os números do CRM do médico": null,
  "Informe os números do primeiro CID do seu atestado": null,
  "Informe os números do quarto CID do seu atestado": null,
  "Informe os números do quinto CID do seu atestado": null,
  "Informe os números do segundo CID do seu atestado": null,
  "Informe os números do terceiro CID do seu atestado": null,
  "Informe qual peso você manteve pelo maior período de tempo no último ano":
    null,
  "Informe qual queixa ou problema motivou a busca da primeira consulta realizada":
    null,
  "Informe qual queixa, problema ou situação motivou o pedido deste exame":
    null,
  "Informe suas alergias alimentares": null,
  intencao_inicial: null,
  "Letra inicial do primeiro CID do seu atestado": null,
  "Letra inicial do quarto CID do seu atestado": null,
  "Letra inicial do quinto CID do seu atestado": null,
  "Letra inicial do segundo CID do seu atestado": null,
  "Letra inicial do terceiro CID do seu atestado": null,
  necessidade: null,
  "Nos conte sua dúvida ou preocupação": null,
  objetivo_consulta: null,
  "Sintomas para COVID": null,
  "Tipo atendimento PBH": null,
};
